import React, { useState, useEffect } from "react";

import DescripcionPerfil from "./DescripcionPerfil";
import EditarPerfil from "./EditarPerfil";
import EliminarSubTitulo from "./EliminaSubTitulo";
import Cookies from "universal-cookie";

function InfoPerfil(props) {
  const cookie = new Cookies();

  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");
  const searcher = (e) => {
    setSearch(e.target.value);
  };
  const results = !search
    ? users
    : users.filter((dato) =>
        dato.nombre.toLowerCase().includes(search.toLocaleLowerCase()),
      );
  useEffect(() => {
    showData();
  }, []);

  const URL =
    "https://suadesarrollo.azurewebsites.net/api/ObtenerPerfilAutoevaluacion/" +
    props.idInstitucion;
  const showData = async () => {
    const response = await fetch(URL);
    const data = await response.json();
    //console.log(data)
    setUsers(data);
  };
  return (
    <div>
      <div>
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>Id</th>
              <th>secciones</th>
              <th>Titulo</th>
              <th>Sub Titulo</th>
              <th>Descripción</th>
              <th>Editar</th>
            </tr>
          </thead>
          <tbody>
            {results.map((item) => {
              return (
                <tr>
                  <td>{item.idregistro}</td>
                  <td>{item.secciones}</td>
                  <td>{item.titulo}</td>
                  <td>{item.subtitulos}</td>
                  <td>
                    <DescripcionPerfil
                      Id={item.idregistro}
                      subtitulo={item.subtitulosId}
                      idInstitucion={cookie.get("institucionid")}
                    />
                  </td>
                  <td>
                    <EditarPerfil
                      Id={item.idregistro}
                      descripcion={item.descripcionIngresada}
                    />
                  </td>
                  <td>
                    <EliminarSubTitulo Id={item.idregistro} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default InfoPerfil;
